import settingsKeyPrefix from "../../gd/settings/local-settings/settings-key";
import SessionEventProto from "../session-event-proto";
import CurrentUser from "../../model2/user/current-user";
import initSentry from "../../gd/errors/sentry";
import {BUS_USER_CHANGE} from "../../gd/bus/bus-event-type";


export default class SessionEventMeChange extends SessionEventProto {


    constructor(sessionEvent:any) {
        super(sessionEvent)

        //     this.restartApps = ['my-account-email'];
    }

    process() {

        let curUserId = localStorage.getItem(settingsKeyPrefix() + 'gd.userId');
        if (curUserId === 'null') curUserId = null;

        // I guess some path for logout / login
        if (curUserId && curUserId!==this.data.id) {
            localStorage.clear();
        }

        // set new curUserId
        localStorage.setItem(settingsKeyPrefix() + 'gd.userId',_.get(this.data, 'id', ''));


        const formatSettings : any = {
            date        : 'MMM D',
            dateLong    : 'ddd, MMM D, YYYY',
            time        : 'h:mm a',
            weekStart   : 'mon'
        };
        if (this.data.datetimeFormat) {
            if (this.data.datetimeFormat.date) formatSettings.date = this.data.datetimeFormat.date;
            if (this.data.datetimeFormat.time) formatSettings.time = this.data.datetimeFormat.time;
            if (this.data.datetimeFormat.dateLong) formatSettings.dateLong = this.data.datetimeFormat.dateLong;
            if (this.data.datetimeFormat.weekStart) formatSettings.weekStart = this.data.datetimeFormat.weekStart;
        }

        // virtual - datetime
        formatSettings.datetime = formatSettings.date + ' ' + formatSettings.time;

        // !!!
        this.data.datetimeFormat = formatSettings

        gd.session.me   = new CurrentUser(this.data)
        gd.user         = gd.session.me

        // Js error tracker Sentry/Raven Sentry.io
        initSentry()


        // Live support set user info... (zopim)
        if (gd.liveSupport) {
            gd.liveSupport.setUserInfo(this.data.name,this.data.email);
        }

        // never implemented I guess
        // gd.translation && gd.translation.changeLanguage(gd.session.me.clientData.labs.interfaceLanguage, ()=>{
        //     //probably should reload page on change (is called only if language really changed)
        //     // console.log("EventMeChange onChangeLanguage");
        // });

        gd.bus.triggerEvent(BUS_USER_CHANGE);
    }



}

